export const VISUALISATION = {
  NONE: 'none',
  QUANTITY: 'quantity',
  CATEGORY: 'category'
}
export const PROMOTED_COLUMN_ID = 'msuuid'
export const LOCATION_MARKER_IMAGE_ID = 'location-marker'
